<div class="content-wrap">
  <div class="row">
    <h2 class="title">
      {{ "reports.title" | translate }}
    </h2>
  </div>
  <div class="row">
    <app-customer-report class="report-section"></app-customer-report>
  </div>
</div>
